import { connect } from 'react-redux';
import _get from 'lodash-es/get';
import ActionProgramsTable from './ActionProgramsTable';
import { getAllProgramsInitiate } from '../../../actions/programs';
import { currentFlowTypeEnum } from '../../common/components/constants';

const mapStateToProps = state => {
  return {
    currentFlow: _get(
      state,
      'user.currentFlow',
      currentFlowTypeEnum.FLOW_TYPE_PPI,
    ),
    selectedWorkspace: _get(state, 'user.selectedWorkspace', {}),
    viewOnlyMode: _get(state, 'user.view_only_mode', false),
    updatingProgramStatus:
      _get(state, 'apiState.UPDATE_PROGRAM_STATUS.isFetching', false) &&
      !_get(state, 'apiState.UPDATE_PROGRAM_STATUS.isIdle', false),
    updateProgramStatusSuccess: _get(
      state,
      'apiState.UPDATE_PROGRAM_STATUS.success',
      false,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getAllPrograms: payload => dispatch(getAllProgramsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActionProgramsTable);
